module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_location-photo-cb018844bfac93b9d584fffe8cec08b0.jpg";